import {SlotsPlaceholder} from '@wix/widget-plugins-ooi';
import classNames from 'classnames';
import React from 'react';
import {ReviewsSlotIds} from '../../constants';
import {ProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';
import {Cell} from '../Layouts/Cell/Cell';
import s from './RatingSummarySlot.scss';

type RatingSummarySlotProps = {
  className?: string;
} & ProvidedGlobalProps;

export const RatingSummarySlot: React.FC<RatingSummarySlotProps> = withGlobalProps(
  ({className, globals}: RatingSummarySlotProps) => {
    const isPluginInstalled = !!globals.slots?.[ReviewsSlotIds.ProductPageDetailsSlot1];
    const cellClass = className ?? s.spacing;

    return (
      <Cell className={classNames(s.root, {[cellClass]: isPluginInstalled})}>
        <SlotsPlaceholder slotId={ReviewsSlotIds.ProductPageDetailsSlot1} />
      </Cell>
    );
  }
);
